import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Icon } from '@mysaiva/core'
import { getAppVersion } from '../../../utils/version'
import { WORKSPACE_MODULE_NAME } from '../constants'
import { workspacePath } from '../navigation'
import styles from './DeveloperPlatformLayout.module.scss'

// Only the certifications in the design (SAIV-11619: HITRUST must not show).
const COMPLIANCE_BADGES = ['HIPAA', 'SOC 2 Type II']

// saiva.ai has no /security or /terms-conditions page (both 404); these are
// the live marketing-site routes (SAIV-11596).
export const DEFAULT_SERVICE_STATUS_URL = 'https://status.saiva.ai/'
export const DEFAULT_TERMS_URL = 'https://saiva.ai/terms-of-use/'
export const DEFAULT_SECURITY_URL = 'https://saiva.ai/trust-and-security/'

export function WorkspaceFooter() {
  const { t } = useTranslation()
  const serviceStatusUrl = import.meta.env.VITE_SERVICE_STATUS_URL || DEFAULT_SERVICE_STATUS_URL
  const termsUrl = import.meta.env.VITE_TERMS_AND_CONDITIONS_URL || DEFAULT_TERMS_URL
  const securityUrl = import.meta.env.VITE_SECURITY_URL || DEFAULT_SECURITY_URL

  return (
    <div className={styles.footer} data-testid="dp-footer">
      <div className={styles.badges} aria-label={t('developerPlatform.footer.compliance')}>
        {COMPLIANCE_BADGES.map(badge => (
          <span key={badge} className={styles.badge} data-testid="dp-footer-badge">
            <Icon icon="CheckCircle" size={12} className={styles.badgeIcon} />
            {badge}
          </span>
        ))}
      </div>
      <nav className={styles.footerLinks}>
        <Link to={workspacePath('api-openapi-preview')}>
          {t('developerPlatform.footer.documentation')}
        </Link>
        <a href={serviceStatusUrl} target="_blank" rel="noopener noreferrer">
          {t('developerPlatform.footer.status')}
        </a>
        <a
          href={securityUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="dp-footer-security"
        >
          {t('developerPlatform.footer.security')}
        </a>
        <a href={termsUrl} target="_blank" rel="noopener noreferrer" data-testid="dp-footer-terms">
          {t('developerPlatform.footer.terms')}
        </a>
      </nav>
      <span className={styles.version} data-testid="dp-version">
        {getAppVersion(WORKSPACE_MODULE_NAME)}
      </span>
    </div>
  )
}
